export default __webpack_public_path__ + "static/media/language-fr.f4af73fd.svg";